import { render, staticRenderFns } from "./ModalViewClient.vue?vue&type=template&id=9525ed5e&scoped=true&"
import script from "./ModalViewClient.vue?vue&type=script&lang=js&"
export * from "./ModalViewClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewClient.vue?vue&type=style&index=0&id=9525ed5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9525ed5e",
  null
  
)

export default component.exports